export default __webpack_public_path__ + "media/images/logo-symbol-wordmark-8c065c2602a0e1833ad42ed8a576d974.svg";